import { CrewMember, Weld, WeldProcedure } from '@bechtel/types';

export interface CreateAdhocRodRequestProps {
  onClose: () => void;
}

export interface FormikState {
  weldProcedure: WeldProcedure | null;
  welders: CrewMember[];
  welds: Weld[];
  comments: string;
}
